// extracted by mini-css-extract-plugin
export default {"root":"check-more_root__2Ek4W","text":"check-more_text__WldwO","chevron":"check-more_chevron__Sm7Tp"};